import { render, staticRenderFns } from "./CompareLearningProgressTable.vue?vue&type=template&id=0604bb32&scoped=true&lang=pug&"
import script from "./CompareLearningProgressTable.vue?vue&type=script&lang=ts&"
export * from "./CompareLearningProgressTable.vue?vue&type=script&lang=ts&"
import style0 from "./CompareLearningProgressTable.vue?vue&type=style&index=0&id=0604bb32&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0604bb32",
  null
  
)

export default component.exports